import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input } from '@angular/core';
import { ApiServiceInterface, CrudComponent, CrudTableComponentInterface, FormServiceInterface } from '@hutsix/ngxh6';
import { LineItemInterface } from '../../../../../_generated/api_interfaces/api/lineItem.interface';
import { Router } from '@angular/router';
import { CartHelpersService } from '../../../../../services/cart-helpers/cart-helpers.service';

@Component({
    selector: 'app-cart-table',
    templateUrl: './cart-table.component.html',
    styleUrls: ['./cart-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CartTableComponent implements CrudTableComponentInterface {
    @Input() public response: ReturnType<LineItemInterface['apiLineItemsGetCollection']>;
    @Input() public crud: CrudComponent;
    @Input() public complete: boolean;

    constructor(
        @Inject('FormService') public formService: FormServiceInterface,
        @Inject('ApiService') public api: ApiServiceInterface,
        public cartHelpers: CartHelpersService,
        private router: Router,
        public cdRef: ChangeDetectorRef,
    ) {}

    public deleteLineItem(orderId: string, productId: string) {
        if (orderId && confirm('Are you sure you want to remove this item from your cart?')) {
            this.api.post({ url: `/api/line_items/remove_all/${orderId}/${productId}`, data: null }).subscribe(() => {
                this.crud.refreshData();
                this.cdRef.detectChanges();
            });
        }
    }

    public deleteAllLineItems(orderId: string) {
        if (orderId && confirm('Are you sure you want to remove all items from your cart?')) {
            this.api.post({ url: `/api/line_items/remove_all/${orderId}`, data: null }).subscribe(() => {
                this.crud.refreshData();
                this.cdRef.detectChanges();
            });
        }
    }

    public updateLineItemCount(orderId: string, productId: string, newCount: number) {
        const opts = {
            url: `/api/line_items/update/${orderId}/${productId}`,
            data: { newCount: newCount },
        };

        this.api.post(opts).subscribe(() => {
            this.crud.refreshData();
            this.cdRef.detectChanges();
        });
    }
}
